import { render, staticRenderFns } from "./AddNewBankAccount.vue?vue&type=template&id=6288bb9d&"
import script from "./AddNewBankAccount.vue?vue&type=script&lang=js&"
export * from "./AddNewBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports